import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import LeftNavSection from "./left-nav-section";
import RightNavSection from "./right-nav-section";
import MetaHead from "@/components/meta/head";
import { useEffect } from "react";
import OnInitHub from "@/services/signal-R/on-receive-hook";
import ThemeSidebar from "./theme-sidebar";
import { useTheme } from "@mui/material";
export default function AppNavBar(props) {
  const { initHub } = OnInitHub();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  useEffect(() => {
    //subscribe all hub on response methods here
    initHub();
  }, []);

  const handleTheme = (e) => {
    console.log(e, "theme");

    setOpen(true);
  };

  return (
    <AppBar
      component="nav"
      sx={{
        backgroundColor: theme.palette.custom.header_bg,
        // backgroundColor: "#fff",
        borderBottom: "1px solid",
        borderBottomColor: "base.40",
        paddingRight: "0 !important",
        zIndex: 1000,
        borderRadius: "0px",
        border: "none",
      }}
      elevation={0}
    >
      <MetaHead />
      <Toolbar>
        <LeftNavSection />
        <RightNavSection handleTheme={handleTheme} />
      </Toolbar>
      <ThemeSidebar open={open} onClose={() => setOpen(false)} />
    </AppBar>
  );
}
